import moment from "moment";
import store from "../Redux/Store";

const setFilename = (type, subtype = undefined) => {
	const {firstName, lastName} = store.getState().auth.user

	return `${moment().format("DDMMYYYYHHmm")}-${firstName}-${lastName}-${type}${subtype ? `-${subtype}` : ''}`
}

export default setFilename
